import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IMealType } from '../models/meal_type';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ClientMealTypeService {
  base_url = environment.baseUrl;
  clientMealTypes = new BehaviorSubject<IMealType[]>([]);
  clientMealTypes$ = this.clientMealTypes.asObservable();
  defaultMealTypes = new BehaviorSubject<IMealType[]>([]);
  defaultMealTypes$ = this.defaultMealTypes.asObservable();

  constructor(private http: HttpClient) {
    console.log(this);

  }

  fetchClientMealTypes(client_id: number, datetime: string, externalDocumentId: number = null): Observable<{ meal_types: IMealType[], default_meal_types: IMealType[], default_metadata?: { healthy_fats?: string, bars_allowed?: boolean, plan_type?: string }, alert?: string }> {
    let url = `${this.base_url}/clients/${client_id}/client_meal_types?datetime=${datetime}`;
    if (externalDocumentId) url += `&external_document_id=${externalDocumentId}`;
    return this.http.get<{ meal_types: IMealType[], default_meal_types: IMealType[], default_metadata?: { healthy_fats?: string, bars_allowed?: boolean, plan_type?: string }, alert?: string }>(url).pipe(
      tap((data) => {
        console.log('got that data', datetime, data)
        this.clientMealTypes.next(data.meal_types)
        this.defaultMealTypes.next(data.default_meal_types)
        console.log("here are the meal types from the server", datetime, data)
      })
    );
  }

  updateClientMealTypes(clientId: number, mealTypes: IMealType[], datetime: string, externalDocumentId: number = null): Observable<IMealType[]> {
    console.log(mealTypes, clientId, datetime);

    const url = `${this.base_url}/clients/${clientId}/client_meal_types/adjust_meal_types`;
    const body: any = { meal_types: mealTypes, datetime };
    if (externalDocumentId) body.external_document_id = externalDocumentId;
    return this.http.put<IMealType[]>(url, body);
  }
}


// First grab all meal types
